import Vue from 'vue'
import Vuex from 'vuex'
import accommodations from './modules/accommodations'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    accommodations
  }
})
